import { IApplicationState } from '../../types/redux';
import { IQuickLinksTab } from '../../types/quickLinks';

export function getQuickLinksTabs(state: IApplicationState): IQuickLinksTab[] {
  return state.quickLinks || [];
}
